import { render, staticRenderFns } from "./ModDragItem.vue?vue&type=template&id=02ff34bb"
import script from "./ModDragItem.vue?vue&type=script&lang=js"
export * from "./ModDragItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports